<script setup lang="ts">
import type { UploadingFile } from '#layers/assets/stores/upload';
import { ButtonRemove } from '#layers/ui';

defineProps<{
	upload: UploadingFile;
}>();

defineEmits<{
	remove: [];
}>();
</script>

<template>
	<div class="flex min-h-30 flex-col items-center justify-center gap-2 rounded-lg border border-error p-3">
		<div class="flex min-w-96 items-center justify-between gap-2 rounded-sm border border-dashed border-error px-3 py-1">
			<FileInfo :file="upload.file" />
			<DTooltip :text="$t('common.remove')">
				<ButtonRemove :trash-bin="false" with-leading-icon square @click="$emit('remove')" />
			</DTooltip>
		</div>
		<p class="text-sm font-medium text-error">
			{{ $t('upload.failed_to_upload_file') }}
		</p>
	</div>
</template>
